import { useQueryWithPreviousData } from "@outschool/ui-apollo";

import {
  FeedbackForCategorySearchFiltersQuery,
  FeedbackForCategorySearchFiltersQueryVariables,
  SearchFilters,
} from "../../../../shared/generated/graphql";
import { CuratedCategoryPageReviewsQuery } from "../../../queries/CuratedCategoryPageQuery";

export function useCuratedCategoryReviewsQuery({
  searchFilters,
  pageLocation,
}: {
  searchFilters: SearchFilters;
  pageLocation: string;
}) {
  return useQueryWithPreviousData<
    FeedbackForCategorySearchFiltersQuery,
    FeedbackForCategorySearchFiltersQueryVariables
  >(CuratedCategoryPageReviewsQuery, {
    variables: { searchFilters, pageLocation },
  });
}
